import * as React from "react"
import { useState, useEffect } from "react"
import HeadComponent from "@components/Head"
import Loading from "@components/Loading"
import Header from "@components/Header"
import FirstView from "@components/FirstView"
import Banner from "@components/Banner"
import AdventCalendar from "@components/AdventCalendar"
import OfficialMerch from "@components/OfficialMerch"
import AboutEvent from "@components/AboutEvent"
import ThemeSong from "@components/ThemeSong"
// import Ornament from "@components/Ornament"
import VotingCampaign from "@components/VotingCampaign"
import Artists from "@components/Artists"
import Footer from "@components/Footer"
import ModalAdventCalendar from "@components/ModalAdventCalendar"
import ModalPopUp from "@components/ModalPopUp"
import ModalThemeSong from "@components/ModalThemeSong"
import useYoutubeModalLogic from "@hooks/useYoutubeModalLogic"
import confetti from "canvas-confetti"

export const Head = () => <HeadComponent />

const IndexPage = () => {
  // サーバーから日付を取得するロジック
  const [serverTime, setServerTime] = useState(null)

  useEffect(() => {
    // UI確認用
    // const newDate = new Date()
    // setServerTime(newDate)

    const updateServerTime = async () => {
      try {
        const response = await fetch(window.location.href, {
          method: "HEAD",
          cache: "no-store",
        })
        const serverDate = new Date(response.headers.get("Date"))
        setServerTime(serverDate)

        // 次の深夜0時までの時間を計算
        const timeToMidnight =
          new Date(
            serverDate.getFullYear(),
            serverDate.getMonth(),
            serverDate.getDate() + 1
          ).getTime() - serverDate.getTime()

        const timeout = setTimeout(async () => {
          await updateServerTime() // 深夜0時に再度サーバー時間を取得
        }, timeToMidnight)

        return () => clearTimeout(timeout)
      } catch (error) {
        console.error("Failed to fetch server date for midnight update:", error)
      }
    }

    updateServerTime()
  }, [])

  // Modal Advent Calendar ロジック
  const [openModal, setOpenModal] = useState(false)
  const [clickedDates, setClickedDates] = useState([])
  const [selectedDate, setSelectedDate] = useState(null)

  useEffect(() => {
    if (typeof window !== "undefined" && window.localStorage) {
      try {
        const storedData = JSON.parse(localStorage.getItem("clickedDates")) || {
          days: [],
        }
        setClickedDates(storedData.days)
      } catch (error) {
        console.error("Error accessing localStorage:", error)
        localStorage.removeItem("clickedDates")
        setClickedDates([])
      }
    } else {
      setClickedDates([])
    }
  }, [])

  const handleOpenModal = date => {
    setSelectedDate(date)
    setOpenModal(true)
    if (typeof window !== "undefined" && window.localStorage) {
      try {
        const storedData = JSON.parse(localStorage.getItem("clickedDates")) || {
          days: [],
        }
        if (!storedData.days.includes(date)) {
          storedData.days.push(date)
          setClickedDates([...clickedDates, date])

          // 紙吹雪アニメ
          confetti({
            particleCount: 300,
            startVelocity: 70,
            spread: 130,
            origin: {
              x: 0.5,
              y: 0.9,
            },
          })
        }
        localStorage.setItem("clickedDates", JSON.stringify(storedData))
      } catch (error) {
        console.error("Error accessing localStorage:", error)
      }
    } else {
      console.warn("localStorage is not available.")
    }
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  // Modal Pop Up用ロジック
  const [showModalPopUp, setShowModalPopUp] = useState(false)
  const [todayDate, setTodayDate] = useState("")

  useEffect(() => {
    if (typeof window !== "undefined" && window.localStorage) {
      try {
        const startDate = new Date("2024-12-02T00:00:00")
        const endDate = new Date("2024-12-25T23:59:59")
        if (serverTime) {
          const date = serverTime.getDate().toString()
          setTodayDate(date)

          const clickedDatesData = JSON.parse(
            localStorage.getItem("clickedDates")
          )
          const clickedDates = clickedDatesData ? clickedDatesData.days : []

          // modal表示条件
          if (
            clickedDates.length > 0 &&
            serverTime >= startDate &&
            serverTime <= endDate &&
            !clickedDates.includes(date)
          ) {
            setShowModalPopUp(true)
          }
        }
      } catch (error) {
        console.error("Error accessing localStorage:", error)
      }
    } else {
      console.warn("localStorage is not available.")
    }
  }, [serverTime])

  const handleCloseModalPopUp = () => {
    setShowModalPopUp(false)
  }

  useEffect(() => {
    if (serverTime) {
      console.log("Updated Server Time (ver1.1.1):", serverTime.toString())
    }
  }, [serverTime])

  // ModalThemeSong用ロジック
  const { showYoutubeModal, openYoutubeModal, hideYoutubeModal, playerRef } =
    useYoutubeModalLogic()
  return (
    <>
      <Loading />
      <div className="wrapper">
        <div className="wrapper-inner">
          <Banner />
          <div className="bg-starry-sky">
            <div className="bg-primary">
              <Header />
              <FirstView />
              <AdventCalendar
                handleOpenModal={handleOpenModal}
                clickedDates={clickedDates}
                serverTime={serverTime}
              />
            </div>
            <OfficialMerch />
            <AboutEvent />
            <ThemeSong openYoutubeModal={openYoutubeModal} />
            {/* Themesongが追加されたらOrnamentはなくす */}
            {/* <Ornament /> */}
            <VotingCampaign />
            <Artists />
          </div>
          <Footer />

          {/* モーダル配置箇所 */}
          <ModalAdventCalendar
            openModal={openModal}
            handleCloseModal={handleCloseModal}
            selectedDate={selectedDate}
          />
          <ModalPopUp
            handleOpenModal={handleOpenModal}
            showModalPopUp={showModalPopUp}
            handleCloseModalPopUp={handleCloseModalPopUp}
            todayDate={todayDate}
          />
          <ModalThemeSong
            showYoutubeModal={showYoutubeModal}
            hideYoutubeModal={hideYoutubeModal}
            playerRef={playerRef}
          />
        </div>
      </div>
    </>
  )
}

export default IndexPage
